/* =========================================================
	SITE-WIDE SCRIPTS
	- UIKit
	- jQuery (if needed)
========================================================= */

/* UIKit ==== */
import UIkit from 'uikit';



/* Literature tabs — hash navigation ==== */
const litNav = document.querySelector('.literature-tabs');
if (litNav) {
	const links = Array.from(litNav.querySelectorAll('a[href^="#"]'));

	links.forEach(a => {
		a.addEventListener('click', () => {
			history.replaceState(null, '', a.getAttribute('href'));
		});
	});

	if (window.location.hash) {
		const idx = links.findIndex(a => a.getAttribute('href') === window.location.hash);
		if (idx !== -1) UIkit.switcher(litNav).show(idx);
	}
}

/* jQuery (if needed) ==== */
import '../js/includes/jquery-global';
import '../js/includes/jquery.cycle2';
import '../js/includes/jquery.cycle2.swipe.min.js';
